import axios from "axios";

export function approveTransfer(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/distributor/admin/api/v1/transfer/${uuid}/approve`, {})
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
